import { render, staticRenderFns } from "./ModalOfferWhatsappTemplates.vue?vue&type=template&id=b70b8b38&scoped=true"
import script from "./ModalOfferWhatsappTemplates.vue?vue&type=script&lang=js"
export * from "./ModalOfferWhatsappTemplates.vue?vue&type=script&lang=js"
import style0 from "./ModalOfferWhatsappTemplates.vue?vue&type=style&index=0&id=b70b8b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70b8b38",
  null
  
)

export default component.exports